export const mattsPublicKeyString = process.env.NEXT_PUBLIC_MATTS_KEY as string
export const TencentIMAppId = process.env.NEXT_PUBLIC_TENCENT_IM_SDK_APP_ID
  ? parseInt(process.env.NEXT_PUBLIC_TENCENT_IM_SDK_APP_ID)
  : 0
